import React from "react";
import Chart from 'react-apexcharts';
import Loader from './../../Pages/Loader';

const PieChart = ({seriesdata=[], labeldata=[], width=380}) =>{

    if(!Array.isArray(seriesdata) || seriesdata.length === 0)
    {
        return <Loader />
    }

    const options = {
                        chart: {
                                width: 450,
                                type: 'pie',
                        },
                        labels: labeldata,
                        responsive: [{
                                    breakpoint: 480,
                                    options: {
                                            chart: {
                                                    width: 300
                                            },
                                            legend: {
                                                    position: 'bottom'
                                            }
                                    }
                        }]
                    };

    return(
        <Chart options={options} series={seriesdata} type="pie" width={450} />
    );
}

export default PieChart;